module.exports = __webpack_public_path__ + "static/media/03.3a57f0ee.jpg";